module.exports = __webpack_public_path__ + "static/media/YF15_2.2c3b328f.jpg";